function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#f90;}.cls-2{fill:#232f3e;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "EC2-instance-contents_dark-bg");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Working"
}, React.createElement("rect", {
  className: "cls-1",
  width: 35,
  height: 35
}), React.createElement("path", {
  className: "cls-2",
  d: "M29.5,11.72v-1H27.15V7.85h-3V5.5h-1V7.85H21V5.5H20V7.85H17.88V5.5h-1V7.85H14.74V5.5h-1V7.85H11.6V5.5h-1V7.85H7.85v2.87H5.5v1H7.85v2.14H5.5v1H7.85V17H5.5v1H7.85v2.14H5.5v1H7.85v2.14H5.5v1H7.85v2.87H10.6V29.5h1V27.15h2.14V29.5h1V27.15h2.14V29.5h1V27.15H20V29.5h1V27.15h2.14V29.5h1V27.15h3V24.28H29.5v-1H27.15V21.14H29.5v-1H27.15V18H29.5V17H27.15V14.86H29.5v-1H27.15V11.72ZM26.15,26.15H8.85V8.85h17.3Z"
}));

var SvgAwsEc2 = function SvgAwsEc2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 35 35",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsEc2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-EC2.8048e73e.svg";
export { ForwardRef as ReactComponent };